export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/course/addLessonName',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['courseById'],
       
    })
